function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M49.5664 41.4928C49.5664 36.2 45.2496 34.7248 41.104 33.7504C37.6944 32.9488 34.6288 32.0912 34.6288 28.8208C34.6288 27.3616 35.2256 24.1744 40 24.1744C43.2992 24.1744 44.9456 26.2096 45.4576 28.744H48.7216C47.7584 25.1936 46.2224 22.0112 41.6 21.2336V17.6H38.4V21.1488C35.7616 21.464 31.1728 23.6544 31.1728 29.1664C31.1728 39.4256 46.1104 34.0752 46.1104 41.8384C46.1104 44.4496 44.9504 46.7536 40 46.7536C35 46.7536 33.6256 42.9504 33.6304 40.8016H30.3664C30.9056 47.7232 35.6576 49.3008 38.4 49.7056V52.8H41.6V49.76C43.9728 49.5312 49.5664 47.7904 49.5664 41.4928Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M60.8 40V4.79999H19.2V40H4.8L40 75.2L75.2 40H60.8Z",
  stroke: "black",
  strokeWidth: 3.2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgLowPrice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowPrice);
export default __webpack_public_path__ + "static/media/low_price.e8143527.svg";
export { ForwardRef as ReactComponent };